import './_styles.scss';
import React from "react";
import { Item } from 'components';

export default ({ data=[] }) => {

  const Placeholder = Array.from(Array(5), (a,i)=>`${a}-${i}`);

  const scroll_handler = async () => {
    const wrapper = document.querySelector('.Scroll-Wrapper');
    if (!wrapper.classList.contains('-margin')) return;
    return wrapper.classList.remove('-margin');
  }

  return (
    <div className='Scrollable-Header'>

      <div className="Item-List-Caption">Best Selling Items</div>

      <div className="Scroll-Wrapper -margin" onScroll={() => scroll_handler()}>

        { (!!data.empty()) && Placeholder.map((a) => <Item key={a} loading/>)}

        { data.map((a,i) =>
          <Item
            key={i}
            id={a.handle}
            title={a.title}
            image={a.images[0]}
            category={a.category}
            price={a.pricing.price}
            brand={a.vendor.toUpperCase()}
          />
        )}
        <div className="Spacer"/>
      </div>
    </div>
  )
}
